module.exports = __webpack_public_path__ + "img/sign_220260566_1.7356121e.png";